module.exports = __webpack_public_path__ + "assets/img/banner6.68282a3f.png";